import {DefaultJobLogo} from '@jobseeker/lotus/assets/icons';
import {Box, Typography, useTheme} from '@mui/material';
import {Image} from '@jobseeker/lotus/components/Image';
import {ImageWithFallback} from '@jobseeker/lotus/components/JobList/V2';
import {useIsLargeDevice} from '@jobseeker/lotus/hooks';
import {useMemo} from 'react';
import {getRandomColor} from '@jobseeker/lotus/theme';
import RecruiterInfo, {RecruiterInfoProps} from './RecruiterInfo';
import Link from 'next/link';
import {cleanUrl} from '@jobseeker/lotus/utils';

type JobTitleProps = {
  id: number;
  title: string;
  companyImgUrl?: string;
  recruiter: RecruiterInfoProps;
};

const JobTitle = ({id, title, companyImgUrl, recruiter}: JobTitleProps) => {
  const imageLoader = () => {
    return companyImgUrl ?? '';
  };

  const randomColor = useMemo(() => getRandomColor(id), [id]);

  const IsLarge = useIsLargeDevice('sm');
  const theme = useTheme();

  return (
    <>
      <Box display="flex" gap={2}>
        {companyImgUrl ? (
          <Box
            position={'relative'}
            sx={{
              borderRadius: '10px',
              '@media (min-width:320px) and (max-width:1000px)': {
                maxWidth: 50,
                maxHeight: 50,
              },
              '@media (min-width:1024px) and (max-width:2556px)': {
                maxWidth: 80,
                maxHeight: 80,
              },
            }}
          >
            <ImageWithFallback
              className="joblist__logo"
              src={companyImgUrl ?? ''}
              fallback={companyImgUrl}
              alt={`${recruiter?.organization?.replace(/\s+/g, '')}_logo'`}
              width={IsLarge ? 80 : 50}
              height={IsLarge ? 80 : 50}
              object-fit="cover"
              quality={50}
              placeholder="blur"
              blurDataURL={companyImgUrl}
              itemId={id}
              loader={imageLoader}
            />
          </Box>
        ) : (
          <Box
            className="joblist__logo"
            sx={{
              background: randomColor,
              p: theme.spacing(1.5),
              height: 'min-content',
              lineHeight: 0,
              borderRadius: '10px',
              maxWidth: 50,
              maxHeight: 50,
            }}
          >
            <Image
              src={DefaultJobLogo}
              alt="Logo"
              width={25}
              height={25}
              objectFit="cover"
              quality={50}
            />
          </Box>
        )}

        <Box display="flex" flexDirection="column" gap={1}>
          <Link
            href={`/j/${cleanUrl(title)}-${id}.html`}
            style={{textDecoration: 'none'}}
            target="_blank"
          >
            <Typography lineHeight="17px" maxWidth={373} color="#000">
              {title}
            </Typography>
          </Link>
          <RecruiterInfo
            name={recruiter.name}
            organization={recruiter?.organization}
            profilePicture={recruiter.profilePicture}
            confidential={recruiter.confidential}
          />
        </Box>
      </Box>
    </>
  );
};

export default JobTitle;
